import Vue from 'vue';
import BackToTopButton from './back-to-top-button.vue';

window.addEventListener("DOMContentLoaded", () => {

  const backToTopButtonContainer = document.querySelector('[data-back-to-top-button-container]');

  if (backToTopButtonContainer) {
    const backToTopOfContainerSelectorString = backToTopButtonContainer.getAttribute('data-back-to-top-tabbable-container-selector-string') || '#main';
    const visibilityThreshold = backToTopButtonContainer.getAttribute('data-visibility-threshold') || 1000;

    new Vue({
      el: backToTopButtonContainer,
      components: { BackToTopButton },
      data: {},
      template: `
        <BackToTopButton
          focusContainerSelector="${backToTopOfContainerSelectorString}"
          visibilityThreshold=${visibilityThreshold}
        />
      `,
    });
  }
});